import { BottomSheet } from "@/design-system/BottomSheet/BottomSheet";
import { SolutionStrategyTag } from "@/design-system/Tags/SolutionTag/SolutionTag";
import { useScrollLock } from "@/hooks/useScrollLock";
import { useTranslation } from "@repo/shared/i18n";

import {
  AlternativeOptionRow,
  UnavailableOptionRow,
} from "./AlternativeOptionRow";
import { AlternativeRow, missingTags } from "./alternativeRow";

/**
 * Mobile: the alternatives as the same full-screen sheet Compare Players and
 * Customize use, with the minimize button in its header. The sheet's own
 * wrapper is the one scroller; the page underneath is locked.
 */
export const AlternativesSheet = ({
  isOpen,
  onClose,
  rows,
  allTags,
  currentId,
  onSelect,
  showTime = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  rows: AlternativeRow[];
  /** Every strategy the solver runs; the ones without a row show greyed. */
  allTags: SolutionStrategyTag[];
  currentId: string;
  onSelect: (id: string) => void;
  /** The build-time column, a Streamline idea. */
  showTime?: boolean;
}) => {
  const { t } = useTranslation("sbcs");
  useScrollLock(isOpen);
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      className="h-dvh max-w-full rounded-none bg-neutral-900"
      header={{
        title: t("streamline.alternatives"),
        closeLabel: t("streamline.closeAlternatives"),
      }}
    >
      <div className="flex flex-col gap-2.5 px-4 pb-6">
        {rows.map((row) => (
          <AlternativeOptionRow
            key={row.id}
            row={row}
            isCurrent={row.id === currentId}
            showTime={showTime}
            onSelect={() => onSelect(row.id)}
          />
        ))}
        {missingTags(rows, allTags).map((tag) => (
          <UnavailableOptionRow key={tag} tag={tag} showTime={showTime} />
        ))}
      </div>
    </BottomSheet>
  );
};
